export default Object.freeze({
    events: 'events',
    family: 'family',
    identity: 'identity',
    news: 'news',
    today: 'today',
    studentClasses: 'student-classes',
    studentDueWork: 'student-due-work',
    studentLearningMoments: 'student-learning-moments',
    studentToday: 'student-today',
    quicklinks: 'quicklinks',
    studentAcademicReports: 'student-academic-reports',
    studentCocurricular: 'student-cocurricular',
})
